import React from 'react'

interface ChatLoaderProps {
  message?: string
  subtitle?: string
}

/**
 * 🔄 Полноэкранный лоадер для чата
 * Отображается поверх всего интерфейса при загрузке сообщений
 */
export const ChatLoader: React.FC<ChatLoaderProps> = ({ 
  message = "Загрузка сообщений...",
  subtitle = "Подключение к чату"
}) => {
  return (
    // Контейнер в рамках виджета чата, но по центру - без рамки
    <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-blue-50/80 to-indigo-50/80 backdrop-blur-sm z-10">
      
      {/* Современный спиннер в стиле как у загрузки изображения */}
      <div className="relative mb-6">
        {/* Орбитальные кольца */}
        <div className="w-16 h-16 relative">
          {/* Внешняя орбита */}
          <div 
            className="absolute inset-0 border-2 rounded-full animate-spin"
            style={{ 
              animation: 'spin 3s linear infinite',
              borderColor: 'rgba(59, 130, 246, 0.1)',
              borderTopColor: '#3b82f6',
              borderRightColor: 'transparent'
            }}
          ></div>
          
          {/* Средняя орбита */}
          <div 
            className="absolute inset-2 border-2 rounded-full"
            style={{ 
              animation: 'spin 2s linear infinite reverse',
              borderColor: 'rgba(59, 130, 246, 0.15)',
              borderTopColor: '#3b82f6',
              borderLeftColor: 'transparent'
            }}
          ></div>
          
          {/* Внутренняя орбита */}
          <div 
            className="absolute inset-4 border-2 rounded-full"
            style={{ 
              animation: 'spin 1.5s linear infinite',
              borderColor: 'rgba(59, 130, 246, 0.2)',
              borderTopColor: '#3b82f6',
              borderBottomColor: 'transparent'
            }}
          ></div>
        </div>
      </div>
      
      {/* Текст без рамки */}
      <div className="text-center space-y-2">
        <h3 className="text-sm font-medium text-gray-800 animate-pulse">
          {message}
        </h3>
        <p className="text-xs text-gray-500 animate-pulse">
          {subtitle}
        </p>
      </div>
      
      {/* Плавающие точки */}
      <div className="flex space-x-1 mt-4">
        <div 
          className="w-2 h-2 rounded-full animate-bounce"
          style={{ 
            backgroundColor: '#3b82f6',
            animationDelay: '0ms' 
          }}
        ></div>
        <div 
          className="w-2 h-2 rounded-full animate-bounce"
          style={{ 
            backgroundColor: 'rgba(59, 130, 246, 0.7)',
            animationDelay: '150ms' 
          }}
        ></div>
        <div 
          className="w-2 h-2 rounded-full animate-bounce"
          style={{ 
            backgroundColor: 'rgba(59, 130, 246, 0.5)',
            animationDelay: '300ms' 
          }}
        ></div>
      </div>
    </div>
  )
}

export default ChatLoader
